/* Info Component on the ScheduleDays component */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../styles/Callsheets.module.css";
import { useCurrentUser } from '../../contexts/CurrentUserContext';

const Info = () => {
  const currentUser = useCurrentUser();
  return (
    <div className='pb-0 mb-3'>
        <Row >
            <Col className={`text-center px-3 py-2 ${styles.SubTitle6 }`}
             md={{span: 10, offset: 1 }}>
              <p className={`${styles.Red} text-center`}>INFO</p>
              <hr className={`mt-2 mb-0`}/>
              {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Superadmin") ? (<>
              <p className='pt-2'>
                  <span className={`${styles.Red}`}>*</span> Click Create Day to create Shoot Days. 
                  Click on a Day to view or add the <span className={`${styles.Red}`}>Stripboard</span>. 
              </p>
              <p className={`${styles.Small} pt-2`}><span className={`${styles.Red}`}></span> Note: If the shoot involves <span className={`${styles.Red}`}>multiple countries</span> the
               Main Unit Schedules and Callsheets are to be used as normal with the relevant 
              city inputted in the Callsheet's <span className={`${styles.Red}`}>Country</span> field.
              </p>
              </>
            ) : (
              <p className='pt-2'>
                  <span className={`${styles.Red}`}>*</span> Click on a Day to view the <span className={`${styles.Red}`}>Stripboard</span>. 
                </p>
            )}
                <hr className={`mt-2 mb-0`}/>
            </Col>
        </Row>
    </div>
  )
}

export default Info